import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable } from 'rxjs';
import { CallbackID, Geolocation, Position } from '@capacitor/geolocation';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  private onPositionChange$: BehaviorSubject<Position> = new BehaviorSubject(null);
  private watchId: CallbackID = null;

  constructor(private log: NGXLogger) {
    Geolocation.watchPosition(
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      },
      (position, err) => this.positionCallback(position, err)
    ).then((watchId) => {
      this.watchId = watchId;
    });
  }

  private positionCallback(position: Position, error: any) {
    if (!this.isPositionError(error)) {
      this.log.debug('position', position);
      this.onPositionChange$.next(position);
    } else {
      // is PositionError
      this.log.debug('position error', error);
    }
  }

  ngOnDestroy(): void {
    if (this.watchId) {
      Geolocation.clearWatch({ id: this.watchId });
    }
  }

  private isPositionError(error: any): boolean {
    return error != null;
  }

  getCurrentPosition(): Promise<Position> {
    // get the last known position
    return Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 300000 ,
    });
  }

  onPositionChange(): Observable<Position> {
    return this.onPositionChange$;
  }
}
